import { ChildItemComponent }       from './dynamic-form/child-item/child-item.component';
import { DynamicFormComponent }     from './dynamic-form/dynamic-form.component';
import { EditModalComponent }       from './dynamic-form/edit-modal/edit-modal.component';
import { IngCheckBoxComponent }     from './dynamic-form/ing-checkbox/ing-checkbox.component';
import { IngRadioButtonComponent }  from './dynamic-form/ing-radio-button/ing-radio-button.component';
import { IngUploadComponent }       from './dynamic-form/ing-upload/ing-upload.component';
import { InputBaseComponent }       from './dynamic-form/input-base/input-base.component';
import { InputsContainerComponent } from './dynamic-form/inputs-container/inputs-container.component';
import { Ng2SelectComponent }       from './dynamic-form/ng2-select/ng2-select.component';
import { SelectChildComponent }     from './dynamic-form/select-child/select-child.component';
import { SelectComponent }          from './dynamic-form/select/select.component';
import { TextAreaComponent }        from './dynamic-form/text-area/text-area.component';
import { TinyMceComponent }         from './dynamic-form/tiny-mce/tiny-mce.component';
import { ChildFormComponent }       from './dynamic-form/child-form/child-form.component';
import { InputImgPreviewComponent } from './dynamic-form/input-img-preview/input-img-preview.component';

export default [
  ChildItemComponent,
  DynamicFormComponent,
  EditModalComponent,
  IngCheckBoxComponent,
  IngRadioButtonComponent,
  IngUploadComponent,
  InputBaseComponent,
  InputsContainerComponent,
  InputImgPreviewComponent,
  Ng2SelectComponent,
  SelectChildComponent,
  SelectComponent,
  TextAreaComponent,
  TinyMceComponent,
  ChildFormComponent
];



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/index.ts